// The person page's card for each mastermind they have (docs/mastermind-admin-plan.md 3.4), right after
// Access, for owner and admin: their group, month and where they stand, the 4 measures in a line, what
// needs Adam, and the 2 ways in, Open in Masterminds (the member view) and Accountability log. It reads
// hub.mastermind_members for just this person, whatever their status, so it shows after an end too.
import { Card, Loading, adminPath, useAdmin, useLoad } from '../ui/index.js'
import { ButtonLink } from '../ui/Page.jsx'
import { MM } from './words.js'
import { loadMembers } from './data.js'
import { cardLines } from './section.js'
import { StandMark } from './Members.jsx'
import { levelFromCounts } from '../../products/mastermind/levels.js'
import '../../styles/admin-masterminds.css'

export function MastermindCard({ personId, product }) {
  const { api, personId: me } = useAdmin()
  const row = useLoad(async () => ((await loadMembers(api, product.id, { person: personId })) || [])[0] || null, [api, product.id, personId])
  const m = row.data
  // a level set by hand reads as the list says it, "On track, set by you" (migration 80)
  const lines = m ? cardLines(m, product, { me }) : null
  return (
    <Card title={product.name} aside={MM.cardAside} className="amx-person-card" id={`mm-card-${product.id}`}>
      {row.status === 'loading' && !m && <Loading />}
      {lines && (
        <>
          <p className="amx-card-stand"><StandMark state={levelFromCounts(m.summary).key}>{lines.line}</StandMark></p>
          <p className="amx-meta">{lines.measures}</p>
          {lines.needs && <p className="amx-strong">{lines.needs}</p>}
        </>
      )}
      <p className="amx-row-actions">
        <ButtonLink size="sm" kind="ink" to={adminPath.mmMember(product.slug, personId)}>{MM.goalAndActions}</ButtonLink>
        <ButtonLink size="sm" to={adminPath.mmLog(product.slug, personId)}>{MM.logButton}</ButtonLink>
      </p>
    </Card>
  )
}
